module.exports = __webpack_public_path__ + "img/banner-ainda-nao-achou.e2e6949c.webp";